/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockStockordertemplateListCtrl
 */
angular.module('mercury.modules.stock.stockordertemplate')
.controller('StockStockordertemplateListCtrl', ["dialog", "$filter", "$scope", "StockOrderTemplates", "title", function(dialog, $filter, $scope, StockOrderTemplates, title) {
  title.set('Stock Order Templates');

  $scope.AllTemplates = StockOrderTemplates.getAll();
  $scope.AllTemplates.$promise.then(function() {
    $scope.creditRequestTemplates = $filter('filter')($scope.AllTemplates, {creditRequest: true});
    $scope.orderTemplates = $filter('filter')($scope.AllTemplates, {creditRequest: false});
  });

  $scope.removeTemplate = function(template, group, index) {
    StockOrderTemplates.remove(template)
    .then(function() {
      group.splice(index, 1);
    });
  };
}]);
